import React, { useEffect, useState } from "react";
import {
  AppBar,
  Backdrop,
  Box,
  Dialog,
  Fab,
  IconButton,
  InputAdornment,
  Slide,
  TextField,
  Toolbar,
  Typography,
  debounce,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "react-query";
import { Add, Close, Search } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";

import { LoadingBox } from "../../../../../components/utils";
import IntegrationAgentsTable from "./components/IntegrationAgentsTable";
import IntegrationAgentDialog from "./components/IntegrationAgentDialog";
import { getIntegrationAgents } from "../../../../services/pwsApi";

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "primary",
    backgroundColor: "rgba(0, 0, 0, 0.25) !important",
  },
  fab: {
    position: "fixed",
    bottom: theme.spacing(10),
    right: theme.spacing(2),
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function IntegrationAgents() {
  const classes = useStyles();
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);

  const companyCode = searchParams.get("company_code");
  const agentId = searchParams.get("agent_id");

  const tablePageIndex = Number(searchParams.get("page") ?? 1);
  const tablePageSize = Number(searchParams.get("page_size") ?? 50);

  const integrationAgentsQuery = useQuery(
    [
      "integration-agents",
      companyCode,
      tablePageIndex,
      tablePageSize,
      searchQuery,
    ],
    () =>
      getIntegrationAgents(
        companyCode.slice(0, 3),
        companyCode.slice(3, 7),
        searchQuery,
      ),
    {
      enabled: !!companyCode,
    },
  );

  useEffect(() => {
    if (agentId) {
      setDialogOpen(true);
    }
  }, [agentId]);

  const handleCloseDialog = () => {
    searchParams.delete("screen");
    setSearchParams(searchParams);
  };

  const handleCloseUserDialog = () => {
    searchParams.delete("agent_id");
    setSearchParams(searchParams);

    setDialogOpen(false);
  };

  const handleCreateIntegrationAgent = () => {
    setDialogOpen(true);
  };

  const searchDelayed = debounce(query => {
    setSearchQuery(query);
  }, 1000);

  const integrationAgents = integrationAgentsQuery?.data?.data?.data ?? [];
  const rows = integrationAgentsQuery?.data?.data?.meta?.total ?? 0;

  return (
    <Dialog
      fullScreen
      open
      onClose={handleCloseDialog}
      TransitionComponent={Transition}
    >
      {dialogOpen && (
        <IntegrationAgentDialog
          onClose={handleCloseUserDialog}
          agentId={agentId}
        />
      )}
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleCloseDialog}
            aria-label="close"
          >
            <Close />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Agentes de integração
          </Typography>
        </Toolbar>
      </AppBar>
      <Backdrop
        className={classes.backdrop}
        open={integrationAgentsQuery?.isLoading ?? true}
      >
        <LoadingBox />
      </Backdrop>
      <Box sx={{ height: "calc(100% - 94px)", padding: "15px" }}>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <TextField
            style={{ width: "400px" }}
            label="Pesquisar"
            variant="outlined"
            fullWidth
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            onChange={event => {
              searchDelayed(event.target.value);
            }}
          />
        </Box>
        <IntegrationAgentsTable data={integrationAgents} rows={rows} />
      </Box>
      <Fab
        color="primary"
        aria-label="add"
        className={classes.fab}
        onClick={handleCreateIntegrationAgent}
      >
        <Add />
      </Fab>
    </Dialog>
  );
}
